const MIME_TYPE = 'application/json'

function load (url, options = {}) {
  if (typeof options.headers === 'undefined') Object.assign(options, { headers: new Headers() })

  if (options.headers.get('Accept') === null) options.headers.set('Accept', MIME_TYPE)

  if (options.body !== undefined && !(options.body instanceof FormData) && options.headers.get('Content-Type') === null) {
    options.headers.set('Content-Type', MIME_TYPE)
  }

  return fetch(url, options).then((response) => {
    if (response.ok) {
      return response
    }
    response.text().then((text) => {
      throw Error(text)
    })
  })
}

function parseSwagger (endpoint) {
  const url = new URL(endpoint)
  const swagger = {
    documentation: undefined,
    entrypoint: `${url.protocol}//${url.host}`
  };

  return load(endpoint + 'docs.json')
    .then((response) => response.json())
    .then((response) => {
      swagger.documentation = response
      swagger.parsed = {}

      function resolveRef ($ref) {
        // is relative?
        if ($ref.substring(0, 14) === '#/definitions/') {
          return response.definitions[$ref.substring(14)]
        }
      }

      function resolveSchema(schema) {
        if (schema === undefined) {
          return undefined;
        }
        if (schema['$ref']) {
          schema = resolveRef(schema['$ref'])
        }
        if (schema.type === 'string' && schema.format && schema.format.substring(0, 14) === 'iri-reference<') {
          schema.reference = schema.format.substring(14, schema.format.length - 1).toLowerCase();
        }
        if (schema.type === 'array') {
          schema.items = resolveSchema(schema.items);
        }
        if (schema.type === 'object') {
          Object.keys(schema.properties).map((propName) => {
            const property = resolveSchema(schema.properties[propName])
            property.required = schema.required && schema.required.indexOf(propName) !== -1
            schema.properties[propName] = property
          })
        }
        return schema;
      }

      function resolveParameters (parameters) {
        const result = {
          parameters: [],
          input: {}
        }
        if (parameters === undefined) {
          return result
        }

        parameters.map((parameter) => {
          if (parameter.in === 'body') {
            result.input = resolveSchema(parameter.schema)
            return
          }
          result.parameters.push({
            in: parameter.in,
            name: parameter.name,
            required: parameter.required,
            schema: resolveSchema(parameter.schema),
            type: parameter.type,
            description: parameter.description
          })
        })
        return result
      }

      Object.keys(response.paths).map((path) => {
        const endpoint = response.paths[path];
        Object.keys(endpoint).map((method) => {
          const operation = endpoint[method];
          const resource = operation['tags'][0].toLowerCase();
          if (swagger.parsed[resource] === undefined) {
            swagger.parsed[resource] = {
              name: resource,
              operations: {}
            }
          }
          let crud_type;
          let input;
          let output;
          switch (method) {
            case 'post':
              crud_type = 'create';
              input = operation.parameters
              if (operation.responses['201']) {
                output = operation.responses['201'].schema
                break;
              }
              if (operation.responses['200']) {
                output = operation.responses['200'].schema
                break;
              }
              // FIXME: If no output, it might be a trigger endpoint that does not produce anything - ignore it for the moment.
              return;
            case 'get':
              output = operation.responses['200'].schema
              if (operation.responses['200'].schema.type === 'array') {
                crud_type = 'list';
                break;
              }
              crud_type = 'show';
              break;
            case 'put':
              crud_type = 'update';
              input = operation.parameters
              if (operation.responses['200']) {
                output = operation.responses['200'].schema
                break;
              }
              break;
            case 'delete':
              crud_type = 'delete';
              break;
          }

          swagger.parsed[resource].operations[crud_type] = {
            url_absolute: swagger.entrypoint + path,
            url: path,
            method: method,
            ...resolveParameters(input),
            output: resolveSchema(output),
            ...operation
          };
        })
      })
      console.log(swagger);
      return swagger;
    })
}

export default parseSwagger
